import React from 'react';
import { Paper, Table } from '@material-ui/core';
import ClinicProductsTableHeader from './ClinicProductsTableHeader';
import ClinicProductsTableBody from './ClinicProductsTableBody';
import { UseFormReturn } from 'react-hook-form';
import { ClinicProduct } from '../../../../apis/clinic-products/types';

interface ClinicProductsTableBodyProps {
  form: UseFormReturn<ClinicProduct[]>;
}

const ClinicVirtualProductEditor = ({ form }: ClinicProductsTableBodyProps) => {
  return (
    <Paper style={{ width: '100%', overflowY: 'auto' }}>
      <Table>
        <ClinicProductsTableHeader />
        <ClinicProductsTableBody form={form} />
      </Table>
    </Paper>
  );
};
export default ClinicVirtualProductEditor;
